import { useState, useContext } from "react";
import api from "../api";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { FaShieldAlt } from "react-icons/fa";
import { Form, Button, Spinner } from "react-bootstrap";

export default function VerifyOTP() {
  const [code, setCode] = useState("");
  const [aadhaar, setAadhaar] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { state } = useLocation();
  const nav = useNavigate();
  const { verify: setVerified } = useContext(AuthContext);
  const { phone, email } = state || {};

  const verify = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // Verify OTP
      await api.post("/auth/verify-otp", { phone, code });
      // Complete profile if email provided
      if (email) {
        await api.post("/auth/complete-profile", { phone, email, aadhaar });
      }
      // Mark as verified in context
      setVerified();
      // Navigate to marketplace
      nav("/market");
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div
        className="verify-card card p-4 shadow-lg border-0 rounded-4"
        style={{ maxWidth: 400, width: "100%" }}
      >
        <div className="text-center mb-4">
          <FaShieldAlt size={48} className="text-primary mb-2" />
          <h3 className="fw-bold text-gradient mb-0">Verify OTP</h3>
          <div className="text-muted mb-2">
            Enter the code sent to your email/phone.
          </div>
        </div>
        <Form onSubmit={verify}>
          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold">OTP Code</Form.Label>
            <Form.Control
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              className="rounded-pill shadow-sm"
            />
          </Form.Group>
          {email && (
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Aadhaar Number</Form.Label>
              <Form.Control
                type="text"
                value={aadhaar}
                onChange={(e) => setAadhaar(e.target.value)}
                placeholder="Enter your Aadhaar number"
                required
                className="rounded-pill shadow-sm"
              />
            </Form.Group>
          )}
          {error && (
            <div className="alert alert-danger text-center rounded-pill py-2">
              {error}
            </div>
          )}
          <Button
            type="submit"
            variant="primary"
            className="w-100 rounded-pill fw-bold py-2 cta-btn"
            disabled={loading}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Verify"}
          </Button>
        </Form>
      </div>
    </div>
  );
}
